import { EMPTY_OBJECT, EMPTY_STRING } from '../../../constants/common'
import { SearchSectionTitle } from '../SearchSectionTitle'

import * as styles from './SearchSectionHeader.module.css'

/**
 * @import {SearchSectionTitleProps} from "../SearchSectionTitle/SearchSectionTitle"
 */

/**
 * @typedef {object} SearchSectionHeaderProps
 *
 * @property {string} [Element]
 * @property {React.ComponentType<SearchSectionTitleProps>} [Title]
 * @property {React.ReactNode} [childreen]
 * @property {string} [className]
 * @property {string} [title]
 * @property {SearchSectionTitleProps} [titleProps]
 */

/**
 * @param {SearchSectionHeaderProps} props
 */
function SearchSectionHeader({
  Element = 'header',
  Title = SearchSectionTitle,
  children,
  className = styles.SearchSectionHeader,
  title = EMPTY_STRING,
  titleProps: {
    className: titleClassName = styles.title,
    ...titleProps
  } = EMPTY_OBJECT,
  ...elementProps
}) {
  return (
    <Element {...elementProps} className={className}>
      <Title {...titleProps} className={titleClassName}>
        {title}
      </Title>
      {children}
    </Element>
  )
}

export default SearchSectionHeader
